export default __webpack_public_path__ + "static/BrettBlethen-3ba4fc3d1408f3ccd6a5520f1ad99c5b.jpg";